import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Alert, AlertTitle } from "@mui/material";
import { SET_ERROR_PROMPT_CMS_PAGE } from "../../../store/actionTypes/cmsActionType";

const ContentTemplateErrorPrompt = () => {
  const dispatch = useDispatch();
  const { t: tCommon } = useTranslation();

  const { isErrorPromptCMSPage: isError, errorMessageCMSPage: errorMessage } =
    useSelector((state) => state.cms);

  const handleClose = (event, reason) => {
    dispatch({ type: SET_ERROR_PROMPT_CMS_PAGE, payload: false });
  };

  return (
    isError && (
      <Alert
        sx={{ my: 2 }}
        severity="error"
        variant="filled"
        onClose={handleClose}
      >
        <AlertTitle>{tCommon("errorPromptTitle")}</AlertTitle>
        {errorMessage}
      </Alert>
    )
  );
};

export default ContentTemplateErrorPrompt;
